import getConfig from 'next/config';

import logger from '@sravni/server-utils/lib/logger';
import { createClient } from '@sravni/ugc/lib/client';

import { isServer } from '../../utils/isServer';

const url = isServer ? process.env.INTERNAL_GATEWAY : getConfig().publicRuntimeConfig.gatewayUrl;

export const GatewayClient = createClient(url, { sentryErrorTagName: 'rating-frontend-gateway', logger });
